export const FeedbackStates = {
  UP: "up",
  DOWN: "down",
  SENDING: "SENDING",
};
